import React, { useContext, useRef, useState } from "react";
import styles from "./Grade.module.scss";
import PathContext from "../../context/path";
const Grade = () => {
  const path = useContext(PathContext);
  const [isVoted, setVoted] = useState(false);
  const [isResponsed, setResponsed] = useState(false);
  const [responseValue, setResponseValue] = useState([1, 7, 25]);
  const refValues = useRef([]);
  const clickHandler = (index) => {
    if (isVoted) return;
    setVoted(true);
    refValues.current[index].classList.add(styles.active);
    let array=[...responseValue];
    array[index] +=1;
    setResponseValue(array);

    // const letterIndex = ['A', 'B' ,'C']
    // submitForm(letterIndex[index]);
  };
  // const submitForm = async (index) => {
  //   let formData = new FormData();
  //   formData.append('range', `${index}2`);
  //   const scriptURL = 'https://script.google.com/macros/s/AKfycbxacJuS8wIL-oXoDuNUigJ1gW3ZNvrnJ10-6z3F8Y5AdMb8dGgIuYaYr8LyaIJMAAltSg/exec';
  //   const response = await fetch(scriptURL, {
  //     method: 'POST',
  //     body: formData
  //   });
  //   if (response.ok) {
  //     const data = await response.json();
  //     console.log(data);
  //     const array = [];
  //     for (const key in data) {
  //       if (Object.hasOwnProperty.call(data, key)) {
  //         const element = data[key];
  //         array.push(element);
  //       }
  //     }
  //     setResponseValue(array);
  //     setResponsed(true);
  //   } else {
  //     console.error('Ошибка при выполнении запроса:', response.statusText);
  //     setResponsed(true);
  //   }
  // };
  return (
    <>
      <div className={isVoted ? `${styles.wrap} ${styles.wrap_disable}` : styles.wrap}>
        <div className={styles.col}>
          <div className={styles.text}>
          У нас получилось?
          </div>
        </div>
        <div className={styles.col} ref={element => refValues.current[0] =  element} onClick={()=>clickHandler(0)}>
          <div className={styles.value}>
            <div className={styles.value__img}>
              <img src={`${path}/img/emodji-1.webp`} alt="" />
            </div>
            <div className={styles.value__number}>{responseValue[0]}</div>
          </div>
        </div>
        <div className={styles.col} ref={element => refValues.current[1] =  element} onClick={()=>clickHandler(1)}>
          <div className={styles.value}>
            <div className={styles.value__img}>
              <img src={`${path}/img/emodji-2.webp`} alt="" />
            </div>
            <div className={styles.value__number}>{responseValue[1]}</div>
          </div>
        </div>
        <div className={styles.col} ref={element => refValues.current[2] =  element} onClick={()=>clickHandler(2)}>
          <div className={styles.value}>
            <div className={styles.value__img}>
              <img src={`${path}/img/emodji-3.webp`} alt="" />
            </div>
            <div className={styles.value__number}>{responseValue[2]}</div>
          </div>
        </div>
      </div>
    </>
  );

}

export default Grade;
